module.exports = __webpack_public_path__ + "static/media/fan1_lamp1.544b91aa.gif";